import { render, staticRenderFns } from "./vpIndex.vue?vue&type=template&id=725cac55&scoped=true"
import script from "./vpIndex.vue?vue&type=script&lang=js"
export * from "./vpIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725cac55",
  null
  
)

export default component.exports